import { DynamicProgrammingProgramsWrapper } from './DynamicProgrammingPrograms.styled';
import AccordionPagination from '../utils/Pagination/AccordionPagination';
import CommentSection from '../utils/CommentSection/CommentSection';

function DynamicProgrammingPrograms() {

   const data = [
      { 
         header: '1. Write a program to generate the first N numbers in the Fibonacci sequence.', 
         body: 
         'public class FibonacciDP {\n'+
         '  public int fibonacci(int n) {\n'+
         '    if (n == 0) return 0;\n'+
         '    if (n == 1) return 1;\n'+
         '	\n'+
         '	// DP array to store Fibonacci numbers\n'+
         '    int[] dp = new int[n + 1]; \n'+
         '    dp[0] = 0;\n'+
         '    dp[1] = 1;\n'+
         '	\n'+
         '    for (int i = 2; i <= n; i++) {\n'+
         '      dp[i] = dp[i - 1] + dp[i - 2];\n'+
         '    }\n'+
         '    return dp[n];\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '2. You are climbing a staircase. It takes n steps to reach the top. Each time you can either climb 1 step or 2 steps. Write a function to determine how many distinct ways you can climb to the top.', 
         body: 
         'public class ClimbingStairs {\n'+
         '  public int climbStairs(int n) {\n'+
         '    if (n == 0 || n == 1) return 1;\n'+
         '	\n'+
         '    int[] dp = new int[n + 1];\n'+
         '	// 1 way to stay at the base\n'+
         '    dp[0] = 1; \n'+
         '	// 1 way to reach the first step\n'+
         '    dp[1] = 1; \n'+
         '	\n'+
         '    for (int i = 2; i <= n; i++) {\n'+
         '      dp[i] = dp[i - 1] + dp[i - 2];\n'+
         '    }\n'+
         '    return dp[n];\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '3. Write a function to determine the maximum amount of money you can rob tonight without robbing any two adjacent houses as it will alert the police.', 
         body: 
         'public class HouseRobber {\n'+
         '  public int rob(int[] nums) {\n'+
         '    int n = nums.length;\n'+
         '	\n'+
         '    if (n == 0) return 0;\n'+
         '    if (n == 1) return nums[0];\n'+
         '	\n'+
         '    int[] dp = new int[n];\n'+
         '    dp[0] = nums[0];\n'+
         '    dp[1] = Math.max(nums[0], nums[1]);\n'+
         '	\n'+
         '    for (int i = 2; i < n; i++) {\n'+
         '      dp[i] = Math.max(dp[i - 1], dp[i - 2] + nums[i]);\n'+
         '    }\n'+
         '    return dp[n - 1];\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '4. Given an array of non-negative integers nums, where each element is your maximum jump length at that position. Determine if you are able to reach the last index, starting from the first index.', 
         body: 
         'public class JumpGameDP {\n'+
         '  public boolean canJump(int[] nums) {\n'+
         '    int n = nums.length;\n'+
         '    boolean[] dp = new boolean[n];\n'+
         '    dp[0] = true;\n'+
         '	\n'+
         '    for (int i = 1; i < n; i++) {\n'+
         '      for (int j = 0; j < i; j++) {\n'+
         '        if (dp[j] && j + nums[j] >= i) {\n'+
         '          dp[i] = true;\n'+
         '          break;\n'+
         '        }\n'+
         '      }\n'+
         '    }\n'+
         '    return dp[n - 1];\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '5. Given an integer array nums, find the contiguous subarray (containing at least one number) which has the largest sum, and return that sum.', 
         body: 
         'public class MaximumSubarrayDP {\n'+
         '  public static int maxSubArray(int[] nums) {\n'+
         '    int n = nums.length;\n'+
         '    int[] dp = new int[n];\n'+
         '	// base case\n'+
         '    dp[0] = nums[0]; \n'+
         '    int maxSum = dp[0];\n'+
         '	\n'+
         '    for (int i = 1; i < n; i++) {\n'+
         '      dp[i] = Math.max(nums[i], dp[i - 1] + nums[i]);\n'+
         '	  //track max sum\n'+
         '      maxSum = Math.max(maxSum, dp[i]); \n'+
         '    }\n'+
         '    return maxSum;\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '6. Given a circular array nums of integers, find the maximum sum of any non-empty contiguous subarray (including possibly wrapping around the end of the array).', 
         body: 
         'public static int maxCircularSubarraySum(int[] nums) {\n'+
         '  int n = nums.length;\n'+
         '  \n'+
         '  // Handle edge case: single element\n'+
         '  if (n == 1) {\n'+
         '    return nums[0];\n'+
         '  }\n'+
         '  int totalSum = 0;\n'+
         '  int maxSum = Integer.MIN_VALUE;\n'+
         '  int minSum = Integer.MAX_VALUE;\n'+
         '  int currentMax = 0;\n'+
         '  int currentMin = 0;\n'+
         '  \n'+
         '  for (int i = 0; i < n; i++) {\n'+
         '    int num = nums[i];\n'+
         '    totalSum += num;\n'+
         '    // Kadane algorithm for maximum subarray\n'+
         '    currentMax = Math.max(num, currentMax + num);\n'+
         '    maxSum = Math.max(maxSum, currentMax);\n'+
         '    // Kadane algorithm for minimum subarray\n'+
         '    currentMin = Math.min(num, currentMin + num);\n'+
         '    minSum = Math.min(minSum, currentMin);\n'+
         '  }\n'+
         '  \n'+
         '  // If all elements are negative, return the maximum element\n'+
         '  if (maxSum < 0) {\n'+
         '    return maxSum;\n'+
         '  }\n'+
         '  return Math.max(maxSum, totalSum - minSum);\n'+
         '}'
      },
      { 
         header: '7. Given an integer array nums, find the contiguous subarray within the array (containing at least one number) which has the largest product, and return that product.', 
         body: 
         'public static int maxProduct(int[] nums) {\n'+
         '    if (nums == null || nums.length == 0) return 0;\n'+
         '	\n'+
         '    int maxSoFar = nums[0];\n'+
         '    int maxEnding = nums[0];\n'+
         '    int minEnding = nums[0];\n'+
         '	\n'+
         '    for (int i = 1; i < nums.length; i++) {\n'+
         '      int current = nums[i];\n'+
         '      // Since maxEnding and minEnding will change, store them temporarily\n'+
         '      int tempMax = maxEnding;\n'+
         '      maxEnding = Math.max(current, Math.max(current * maxEnding, current * minEnding); \n'+
         '	  minEnding = Math.min(current, Math.min(current * tempMax, current * minEnding)); \n'+
         '	  maxSoFar = Math.max(maxSoFar, maxEnding);\n'+
         '    }\n'+
         '	return maxSoFar;\n'+
         '}'
      },
      { 
         header: '8. Given an array prices where prices[i] is the price of a given stock on day i. Return the maximum profit by choosing a day to buy one stock and choosing a different day in the future to sell that stock.', 
         body: 
         'public static int maxProfit(int[] prices) {\n'+
         '  if (prices == null || prices.length == 0) return 0;\n'+
         '  \n'+
         '  int minPriceSoFar = prices[0];\n'+
         '  int maxProfit = 0;\n'+
         '  \n'+
         '  for (int i = 1; i < prices.length; i++) {\n'+
         '    // Update the min price if we find a lower price\n'+
         '    minPriceSoFar = Math.min(minPriceSoFar, prices[i]);\n'+
         '    // Calculate the profit if we sell today\n'+
         '    int profitToday = prices[i] - minPriceSoFar;\n'+
         '    // Update maxProfit if profit today is higher\n'+
         '    maxProfit = Math.max(maxProfit, profitToday);\n'+
         '  }\n'+
         '  return maxProfit;\n'+
         '}'
      },
      { 
         header: '9. Given N items, where each item has a weight and a value, along with a knapsack with a maximum capacity W. Your goal is to maximize the total value of items that can be placed into the knapsack without exceeding the capacity.', 
         body: 
         'public static int knapsack(int[] weights, int[] values, int capacity) {\n'+
         '  int n = weights.length;\n'+
         '  int[] dp = new int[capacity + 1];\n'+
         '  \n'+
         '  // Loop through each item\n'+
         '  for (int i = 0; i < n; i++) {\n'+
         '    // Loop backward through capacities\n'+
         '    for (int w = capacity; w >= weights[i]; w--) {\n'+
         '      dp[w] = Math.max(dp[w], dp[w - weights[i]] + values[i]);\n'+
         '    }\n'+
         '  }\n'+
         '  return dp[capacity];\n'+
         '}'
      },
      { 
         header: '10. Given a set of n non-negative integers and a value target, determine whether there exists a subset of the given set with a sum equal to target.', 
         body: 
         'public static boolean isSubsetSum(int[] nums, int target) {\n'+
         '  boolean[] dp = new boolean[target + 1];\n'+
         '  // Base case\n'+
         '  dp[0] = true; \n'+
         '  \n'+
         '  for (int num: nums) {\n'+
         '    for (int j = target; j >= num; j--) {\n'+
         '      dp[j] = dp[j] || dp[j - num];\n'+
         '    }\n'+
         '  }\n'+
         '  return dp[target];\n'+
         '}'
      },
      { 
         header: '11. Given a non-empty array nums containing only positive integers, determine if the array can be partitioned into two subsets such that the sums of the elements in both subsets are equal.', 
         body: 
         'public static boolean canPartition(int[] nums) {\n'+
         '  int totalSum = 0;\n'+
         '  \n'+
         '  for (int num: nums) totalSum += num;\n'+
         '  \n'+
         '  // If total sum is odd, it cannot be partitioned\n'+
         '  if (totalSum % 2 != 0) return false;\n'+
         '  int target = totalSum / 2;\n'+
         '  \n'+
         '  boolean[] dp = new boolean[target + 1];\n'+
         '  // Base case\n'+
         '  dp[0] = true; \n'+
         '  \n'+
         '  for (int num: nums) {\n'+
         '    for (int j = target; j >= num; j--) {\n'+
         '      dp[j] = dp[j] || dp[j - num];\n'+
         '    }\n'+
         '  }\n'+
         '  return dp[target];\n'+
         '}'
      },
      { 
         header: '12.Given an array of integers nums and an integer target, you need to find the number of ways to assign + or - signs to each element in nums such that the resulting expression evaluates to target.', 
         body: 
         'public static int findTargetSumWays(int[] nums, int target) {\n'+
         '  int totalSum = 0;\n'+
         '  \n'+
         '  for (int num: nums) totalSum += num;\n'+
         '  \n'+
         '  // Check for invalid case\n'+
         '  if ((target + totalSum) % 2 != 0 || Math.abs(target) > totalSum)\n'+
         '    return 0;\n'+
         '	\n'+
         '  int subsetSum = (target + totalSum) / 2;\n'+
         '  int[] dp = new int[subsetSum + 1];\n'+
         '  // Base case: one way to get sum 0\n'+
         '  dp[0] = 1; \n'+
         '  \n'+
         '  for (int num: nums) {\n'+
         '    for (int i = subsetSum; i >= num; i--) {\n'+
         '      dp[i] += dp[i - num];\n'+
         '    }\n'+
         '  }\n'+
         '  return dp[subsetSum];\n'+
         '}'
      },
      { 
         header: '13. Given N items, each with a weight and a value, and a knapsack with a maximum capacity W. Determine the maximum total value that can be put into the knapsack without exceeding the capacity. (you can use each item unlimited times)', 
         body: 
         'public static int unboundedKnapsack(int[] weights, int[] values, int capacity) {\n'+
         '  int n = weights.length;\n'+
         '  int[] dp = new int[capacity + 1];\n'+
         '  \n'+
         '  // Loop through all capacities\n'+
         '  for (int w = 0; w <= capacity; w++) {\n'+
         '    for (int i = 0; i < n; i++) {\n'+
         '      if (weights[i] <= w) {\n'+
         '        dp[w] = Math.max(dp[w], dp[w - weights[i]] + values[i]);\n'+
         '      }\n'+
         '    }\n'+
         '  }\n'+
         '  return dp[capacity];\n'+
         '}'
      },
      { 
         header: '14. Given an integer array coins representing different denominations of coins and an integer amount representing a total amount of money, write a program to compute the fewest number of coins that you need to make up that amount.', 
         body: 
         'public static int coinChange(int[] coins, int amount) {\n'+
         '  int[] dp = new int[amount + 1];\n'+
         '  \n'+
         '  // Initialize with a large value (infinity)\n'+
         '  Arrays.fill(dp, Integer.MAX_VALUE);\n'+
         '  // base case\n'+
         '  dp[0] = 0; \n'+
         '  \n'+
         '  for (int coin: coins) {\n'+
         '    for (int j = coin; j <= amount; j++) {\n'+
         '      if (dp[j - coin] != Integer.MAX_VALUE) {\n'+
         '        dp[j] = Math.min(dp[j], dp[j - coin] + 1);\n'+
         '      }\n'+
         '    }\n'+
         '  }\n'+
         '  return (dp[amount] == Integer.MAX_VALUE) ? -1 : dp[amount];\n'+
         '}'
      },
      { 
         header: '15. Given an integer array coins representing different denominations of coins and an integer amount, compute the number of combinations that make up the amount.', 
         body: 
         'public int change(int amount, int[] coins) {\n'+
         '  int[] dp = new int[amount + 1];\n'+
         '  // base case\n'+
         '  dp[0] = 1; \n'+
         '  \n'+
         '  for (int coin: coins) {\n'+
         '    for (int j = coin; j <= amount; j++) {\n'+
         '      dp[j] += dp[j - coin];\n'+
         '    }\n'+
         '  }\n'+
         '  return dp[amount];\n'+
         '}'
      },
      { 
         header: '16. Given a rod of length n inches and an array prices[] where prices[i] denotes the price of a rod piece of length i + 1, determine the maximum revenue you can obtain by cutting the rod into pieces and selling them.', 
         body: 
         'public static int rodCutting(int[] prices, int n) {\n'+
         '  int[] dp = new int[n + 1];\n'+
         '  dp[0] = 0;\n'+
         '\n'+
         '  for (int i = 1; i <= n; i++) {\n'+
         '    dp[i] = Integer.MIN_VALUE;\n'+
         '\n'+
         '    for (int j = 1; j <= i; j++) {\n'+
         '      dp[i] = Math.max(dp[i], price[j - 1] + dp[i - j]);\n'+
         '    }\n'+
         '\n'+
         '  }\n'+
         '\n'+
         '  return dp[n];\n'+
         '}'
      },
      { 
         header: '17. Given two strings textl and text2, find the length of their Longest Common Subsequence. A common subsequence of two strings is a subsequence that appears in both strings.', 
         body: 
         'public static int longestCommonSubsequence(String text1, String text2) {\n'+
         '  int m = text1.length();\n'+
         '  int n = text2.length();\n'+
         '  \n'+
         '  // Only store previous and current rows\n'+
         '  int[] prev = new int[n + 1];\n'+
         '  int[] curr = new int[n + 1];\n'+
         '  \n'+
         '  for (int i = 1; i <= m; i++) {\n'+
         '    for (int j = 1; j <= n; j++) {\n'+
         '      if (text1.charAt(i - 1) == text2.charAt(j - 1)) {\n'+
         '        curr[j] = prev[j - 1] + 1;\n'+
         '      } else {\n'+
         '        curr[j] = Math.max(prev[j], curr[j - 1]);\n'+
         '      }\n'+
         '    }\n'+
         '	\n'+
         '    // Swap current and previous\n'+
         '    int[] temp = prev;\n'+
         '    prev = curr;\n'+
         '    curr = temp;\n'+
         '  }\n'+
         '  return prev[n];\n'+
         '}'
      },
      { 
         header: '18. Given two strings wordl and word2, return the minimum number of operations (insert, delete, replace character) required to convert wordl into word2.', 
         body: 
         'public static int minDistance(String word1, String word2) {\n'+
         '  int m = word1.length();\n'+
         '  int n = word2.length();\n'+
         '  int[] prev = new int[n + 1];\n'+
         '  int[] dp = new int[n + 1];\n'+
         '  \n'+
         '  // Base case: converting "" > word2\n'+
         '  for (int j = 0; j <= n; j++) {\n'+
         '    prev[j] = j;\n'+
         '  }\n'+
         '\n'+
         '  for (int i = 1; i <= m; i++) {\n'+
         '	// converting word1 >""\n'+
         '    dp[0] = i; \n'+
         '    for (int j = 1; j <= n; j++) {\n'+
         '      if (word1.charAt(i - 1) == word2.charAt(j - 1)) {\n'+
         '		// no operation\n'+
         '        dp[j] = prev[j - 1]; \n'+
         '      } else {\n'+
         '        dp[j] = 1 + Math.min(\n'+
         '          prev[j], // delete\n'+
         '          Math.min(dp[j - 1], // insert\n'+
         '          prev[j - 1]) // replace\n'+
         '        );\n'+
         '      }\n'+
         '    }\n'+
         '    // move current row to prev\n'+
         '    int[] temp = prev;\n'+
         '    prev = dp;\n'+
         '    dp = temp;\n'+
         '  }\n'+
         '  return prev[n];\n'+
         '}'
      },
      { 
         header: '19. Given a string s, return the length of the longest subsequence of s that is also a palindrome. A palindrome is a string that reads the same forward and backward.', 
         body: 
         'public static int longestPalindromeSubseq(String s) {\n'+
         '  int n = s.length();\n'+
         '  int[] dp = new int[n];\n'+
         '  \n'+
         '  // Traverse from end of string to beginning\n'+
         '  for (int i = n - 1; i >= 0; i--) {\n'+
         '    int prev = 0;\n'+
         '	\n'+
         '	// Base case: single character\n'+
         '    dp[i] = 1; \n'+
         '	\n'+
         '    for (intj = i + 1; j < n; j++) {\n'+
         '      // Save current dp[j] for next iteration\n'+
         '      int temp = dp[j];\n'+
         '      if (s.charAt(i) == s.charAt(j)) {\n'+
         '        dp[j] = prev + 2;\n'+
         '      } else {\n'+
         '        dp[j] = Math.max(dp[j], dp[j - 1]);\n'+
         '      }\n'+
         '      prev = temp;\n'+
         '    }\n'+
         '  }\n'+
         '  return dp[n - 1];\n'+
         '}'
      },
      { 
         header: '20. Given two strings s and t, return the number of distinct subsequences of s which equal t. A subsequence of a string is a string formed by deleting some or no characters from the original string preserving the order of the characters.', 
         body: 
         'public static int numDistinct(String s, String t) {\n'+
         '  int m = s.length(), n = t.length();\n'+
         '  \n'+
         '  // Edge case\n'+
         '  if (n > m) return 0;\n'+
         '  int[] dp = new int[n + 1];\n'+
         '  \n'+
         '  // Empty t is a subsequence of any prefix of s\n'+
         '  dp[0] = 1;\n'+
         '  \n'+
         '  for (int i = 1; i <= m; i++) {\n'+
         '    // Go backwards to avoid overwriting dp[j - 1] before using it\n'+
         '    for (int j = n; j >= 1; j--) {\n'+
         '      if (s.charAt(i - 1) == t.charAt(j - 1)) {\n'+
         '        dp[j] += dp[j - 1];\n'+
         '      }\n'+
         '      // else: dp[j] remains same as before (skip s[i-1])\n'+
         '    }\n'+
         '  }\n'+
         '  return dp[n];\n'+
         '}'
      }
      
    ];

   return (
      <DynamicProgrammingProgramsWrapper>
         <header className="entry-header">
            <h1 className="entry-title" itemProp="headline">Dynamic Programming Interview Programs</h1>
         </header>
         <br/>
         <AccordionPagination accordionData={data} />
         <br/>
         <CommentSection />
      </DynamicProgrammingProgramsWrapper>
   )
};

export default DynamicProgrammingPrograms;
